import {
    createSlice,
    createAsyncThunk,
    PayloadAction,
    createAction,
} from "@reduxjs/toolkit";
import {
    MotorDto, MotorInput,
    MotorOilType_WARNINGDto, MotorPerformanceDto, MotorPerformancePlotData
} from "../../../../src/store/model/calculations/motor";
import * as motorService from "../../../services/calculations/calculation-output/motor.service";
import { Equipment } from "../../model/calculations/calculation";

interface State {
    loading: boolean;
    error: string | null;
    MotorInput: MotorInput,
    MotorList: MotorDto[],
    MotorOilWarning: MotorOilType_WARNINGDto,
    MotorperformanceList: MotorPerformanceDto[],
    fluidVelocity: string,
    ShroudODList: any,
    ShroudWTList: any,
    SensorList: Equipment[],
    FluidVelocityPostMotor: string,
    MotorCalculationComplete: boolean
    MotorPerformancePlotData: MotorPerformancePlotData | null,
    MotorDeratingAmps: number,
    MotorDeratingHP: number,
    MotorDeratingVolts: number,
    Equipments: Equipment[],
    EquipmentsForSensor: Equipment[],
    ESPEquipments: Equipment[],
    MotorSeries: string,
    ESPEquipmentsForSensor: Equipment[],
    SelectedMotorId: string,
    SelectedMotor: MotorDto | null,
    motor_HPInput?: number
}

export const initialState: State = {
    loading: false,
    error: null,
    MotorInput: { motorLoad: 100, motor_HPInput: 0, motor_HP60Input: 0 },
    MotorList: [],
    MotorOilWarning: { MaxTemp: 0, MinTemp: 0 },
    MotorperformanceList: [],
    fluidVelocity: '',
    ShroudODList: null,
    ShroudWTList: null,
    SensorList: [],
    FluidVelocityPostMotor: '',
    MotorCalculationComplete: false,
    MotorPerformancePlotData: null,
    MotorDeratingAmps: 0,
    MotorDeratingHP: 0,
    MotorDeratingVolts: 0,
    Equipments: [],
    EquipmentsForSensor: [],
    ESPEquipments: [],
    MotorSeries: '',
    ESPEquipmentsForSensor: [],
    SelectedMotorId: '',
    SelectedMotor: null,
    motor_HPInput: 0
};
export const setFetchEquipments = createAction("motor/fetchEquipments");


const motorSlice = createSlice({
    name: "motor",
    initialState,
    reducers: {
        resetMotorOutput: () => initialState,
        resetMotorFields: (state) => {
            //state.PumpIteration = [];
        },
        setMotorList: (state, action: PayloadAction<MotorDto[]>) => {
            state.MotorList = action.payload;
        },
        setMotorLoadInput: (state, action: PayloadAction<any>) => {
            state.MotorInput.motorLoad = action.payload;
        },
        setMotorInput: (state, action: PayloadAction<any>) => {
            state.MotorInput = action.payload;
        },
        setMotorInputHP: (state, action: PayloadAction<any>) => {
            state.motor_HPInput = action.payload;
        },
        setMotorDeRatingAmps: (state, action: PayloadAction<any>) => {
            state.MotorDeratingAmps = action.payload;
        },
        setMotorDeRatingHp: (state, action: PayloadAction<any>) => {
            state.MotorDeratingHP = action.payload;
        },
        setMotorDeRatingVolts: (state, action: PayloadAction<any>) => {
            state.MotorDeratingVolts = action.payload;
        },
        setMotorInputHP60: (state, action: PayloadAction<any>) => {
            state.MotorInput = {
                ...state.MotorInput,
                motor_HP60Input: action.payload,
            }
        },
        setSelectedMotor: (state, action: PayloadAction<any>) => {
            state.SelectedMotor = action.payload;
        },
        setMotorPerformanceData: (state, action: PayloadAction<any>) => {
            state.MotorperformanceList = action.payload;
        },
        setMotorCalculationComplete: (state, action: PayloadAction<boolean>) => {
            state.MotorCalculationComplete = action.payload;
        },
        setFluidVelocity: (state, action: PayloadAction<any>) => {
            state.fluidVelocity = action.payload;
        },
        setShroudODList: (state, action: PayloadAction<any>) => {
            state.ShroudODList = action.payload;
        },
        setShroudWeightList: (state, action: PayloadAction<any>) => {
            state.ShroudWTList = action.payload;
        },
        setFluidVelocityPostMotor: (state, action: PayloadAction<any>) => {
            state.FluidVelocityPostMotor = action.payload;
        },
        setMotorPerformancePlotData: (state, action: PayloadAction<any>) => {
            state.MotorPerformancePlotData = action.payload;
        },
        setESPEquipmentsForMotor: (state, action) => {

            state.ESPEquipments = action.payload;
        },
        setEquipmentsForMotor: (state, action: PayloadAction<any[]>) => {
            state.Equipments = action.payload.map((equipment) => ({
                ...equipment,
                text: equipment?.pN_Description,
                diameter: equipment?.od?.toString(),
                pn: equipment?.pn ?? equipment?.partNumber,
            }));
        },
        setMotorSensorList: (state, action: PayloadAction<any>) => {
            state.EquipmentsForSensor = action.payload.map((sensor: Equipment) => ({
                ...sensor,
                text: sensor?.name,
                id: sensor?.sensorId
            }));
        },
        setESPEquipmentForSensor: (state, action: PayloadAction<any>) => {
            state.ESPEquipmentsForSensor = action.payload.map((sensor: Equipment) => ({
                ...sensor,
                pN_Description: sensor?.name
            }));
        },
        setMotorOilWarning: (state, action: PayloadAction<any>) => {
            state.MotorOilWarning = action.payload;
        },

    },
});

export const {
    resetMotorOutput,
    resetMotorFields,
    setMotorLoadInput,
    setMotorInput,
    setMotorInputHP,
    setMotorInputHP60,
    setMotorList,
    setSelectedMotor,
    setMotorPerformanceData,
    setShroudODList,
    setFluidVelocity,
    setMotorSensorList,
    setShroudWeightList,
    setFluidVelocityPostMotor,
    setMotorCalculationComplete,
    setMotorPerformancePlotData,
    setESPEquipmentsForMotor,
    setEquipmentsForMotor,
    setESPEquipmentForSensor,
    setMotorOilWarning,
    setMotorDeRatingAmps,
    setMotorDeRatingHp,
    setMotorDeRatingVolts

} = motorSlice.actions;

export default motorSlice.reducer;
